import {
    createRoutesFromElements,
    Route,
    createBrowserRouter,
    RouterProvider,
    Navigate,
} from 'react-router-dom';
import ErrorPage from './views/ErrorPage';
import NoAccessPage from './views/NoAccessPage';
import PageNotFoundPage from './views/PageNotFoundPage';
import RevStatsAuthenticatedContainer from './RevStatsAuthenticatedContainer';
import UnhandledExceptionErrorBoundary from '../common/containers/UnhandledExceptionErrorBoundary';
import MobileFriendlyContainer from '../common/containers/MobileFriendlyContainer';
import LogsPageProvider from '../common/components/LogsPage/LogsPageProvider';
import ConfidentialFooterContainer from '../common/containers/ConfidentialFooterContainer';

const router = createBrowserRouter(
    createRoutesFromElements(
        <Route element={<UnhandledExceptionErrorBoundary />} errorElement={<ErrorPage />}>
            <Route element={<RevStatsAuthenticatedContainer />}>
                <Route element={<MobileFriendlyContainer />}>
                    <Route element={<ConfidentialFooterContainer />}>
                        <Route
                            path="/"
                            lazy={() =>
                                import(/* webpackChunkName: 'HomePage' */ './views/HomePage')
                            }
                        />
                        <Route
                            path="/areas/:areaId"
                            lazy={() =>
                                import(
                                    /* webpackChunkName: 'AreaPageContainer' */ './views/areas/AreaPageContainer'
                                )
                            }
                        >
                            <Route
                                path=""
                                lazy={() =>
                                    import(
                                        /* webpackChunkName: 'AreaPage' */ './views/areas/AreaPage'
                                    )
                                }
                            />
                            <Route
                                path="customers"
                                lazy={() =>
                                    import(
                                        /* webpackChunkName: 'AreaCustomersPage' */ './views/areas/AreaCustomersPage'
                                    )
                                }
                            />
                            <Route
                                path="suites/:suiteId"
                                lazy={() =>
                                    import(
                                        /* webpackChunkName: 'SuitePage' */ './views/suites/SuitePage'
                                    )
                                }
                            />
                            <Route
                                path="suites/:suiteId/customers"
                                lazy={() =>
                                    import(
                                        /* webpackChunkName: 'SuiteCustomersPage' */ './views/suites/SuiteCustomersPage'
                                    )
                                }
                            />
                            <Route
                                path="suites/:suiteId/products/:productId"
                                lazy={() =>
                                    import(
                                        /* webpackChunkName: 'ProductPage' */ './views/products/ProductPage'
                                    )
                                }
                            />
                            <Route
                                path="suites/:suiteId/products/:productId/customers"
                                lazy={() =>
                                    import(
                                        /* webpackChunkName: 'ProductPage' */ './views/products/ProductCustomersPage'
                                    )
                                }
                            />
                            <Route
                                path="suites/:suiteId/products/:productId/categories/:categoryId"
                                element={<Navigate to="customers" replace />}
                            />
                            <Route
                                path="suites/:suiteId/products/:productId/categories/:categoryId/customers"
                                lazy={() =>
                                    import(
                                        /* webpackChunkName: 'ProductPage' */ './views/categories/CategoryCustomersPage'
                                    )
                                }
                            />
                        </Route>
                        <Route
                            path="/search"
                            lazy={() =>
                                import(
                                    /* webpackChunkName: 'SearchPage' */ './views/search/RevStatsSearchPage'
                                )
                            }
                        />
                        <Route path="/help">
                            <Route
                                path=""
                                lazy={() =>
                                    import(
                                        /* webpackChunkName: 'HelpPage' */ './views/help/RevStatsHelpPage'
                                    )
                                }
                            />
                        </Route>
                        <Route
                            path="/customers/:customerId"
                            lazy={() =>
                                import(
                                    /* webpackChunkName: 'CustomerPageContainer' */ './views/customers/CustomerPageContainer'
                                )
                            }
                        >
                            <Route
                                path=""
                                lazy={() =>
                                    import(
                                        /* webpackChunkName: 'CustomerPage' */ './views/customers/CustomerPage'
                                    )
                                }
                            />
                        </Route>
                        <Route
                            path="/products"
                            lazy={() =>
                                import(
                                    /* webpackChunkName: 'ProductsListPage' */ './views/products/ProductsListPage'
                                )
                            }
                        />
                    </Route>
                    <Route
                        path="/admin"
                        lazy={() =>
                            import(
                                /* webpackChunkName: 'AdminPageContainer' */ './views/admin/RevStatsAdminPageContainer'
                            )
                        }
                    >
                        <Route
                            path=""
                            lazy={() =>
                                import(
                                    /* webpackChunkName: 'AdminLandingPage' */ './views/admin/RevStatsAdminLandingPage'
                                )
                            }
                        />
                        <Route
                            path="users"
                            lazy={() =>
                                import(
                                    /* webpackChunkName: 'ManageUsers' */ './views/admin/RevStatsManageUsersPage'
                                )
                            }
                        />
                    </Route>
                </Route>
                <Route
                    element={
                        <LogsPageProvider>
                            <MobileFriendlyContainer />
                        </LogsPageProvider>
                    }
                >
                    <Route element={<ConfidentialFooterContainer />}>
                        <Route
                            path="/logs"
                            lazy={() =>
                                import(/* webpackChunkName: 'LogsPage' */ './views/LogsPage')
                            }
                        />
                    </Route>
                </Route>
            </Route>
            <Route
                path="/login"
                lazy={() => import(/* webpackChunkName: 'LoginPage' */ './views/LoginPage')}
            />
            <Route path="/error" element={<ErrorPage />} />,
            <Route path="/no-access" element={<NoAccessPage />} />
            <Route path="*" element={<PageNotFoundPage />} />
        </Route>,
    ),
);

export default function App() {
    return <RouterProvider router={router} />;
}
